// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"112":"work","420":"message","539":"misc","644":"account","857":"report","884":"admin"}[chunkId] || chunkId) + "." + {"112":"3bb82b83","211":"006a96b9","368":"5f2bf413","420":"5ace2482","539":"4a00454e","644":"ec844c75","857":"0740fdf4","884":"4326e660","945":"0f234cad"}[chunkId] + ".js";
};